module.exports = __webpack_public_path__ + "static/img/grouplogo.345b85ec.png";